import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import ScreenLoaderAnimation from './ScreenLoaderAnimation';

function PageLoader({ className, width, isWhite }) {
  return (
    <div
      className={cn(
        'w-full h-full pointer-events-none bg-white bg-opacity-100',
        className
      )}
    >
      <div className="flex justify-center items-center h-full bg-opacity-0">
        <ScreenLoaderAnimation width={width} isWhite={isWhite} />
      </div>
    </div>
  );
}

PageLoader.defaultProps = {
  className: '',
  width: '220px',
  isWhite: false,
};

PageLoader.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  isWhite: PropTypes.bool,
};

export default PageLoader;
